import React from 'react';
import PropTypes from 'prop-types';
import Dialog from 'components/modals/Dialog';
import DialogTitle from 'components/modals/DialogTitle';
import OpportunityForm from './OpportunityForm';

const AddOpportunity = ({
  toggle, initialValues, readOnly,
}) => {
  const formTitle = initialValues && initialValues.id ? 'Edit opportunity' : 'Add opportunity';
  return (
    <Dialog open onBackdropClick={toggle}>
      <DialogTitle disableTypography>
        {readOnly ? 'Preview' : formTitle}
      </DialogTitle>
      <OpportunityForm readOnly={readOnly} initialValues={initialValues} toggle={toggle} />
    </Dialog>
  );
};

AddOpportunity.propTypes = {
  readOnly: PropTypes.bool,
  toggle: PropTypes.func.isRequired,
  initialValues: PropTypes.element,
};

AddOpportunity.defaultProps = {
  initialValues: {},
  readOnly: false,
};

export default AddOpportunity;
